<template>
  <div>
    <article v-for="season in seasons" :key="season._id">
      <header>
        <SeasonInfo :season="season" />
      </header>
      <div><slot v-bind:season="season" /></div>
    </article>
  </div>
</template>

<script>
import SeasonInfo from '@/components/SeasonInfo.vue'

export default {
  name: 'SeasonList',
  props: ['seasons'],
  components: { SeasonInfo }
}
</script>

<style scoped>
article + article {
  margin-top: 2.5emem;
}
article > div {
  padding-top: 2.5em;
  &:empty {
    display: none;
  }
}
@mixin breakpoint-small {
  article + article {
    margin-top: 4em;
  }
  article > div {
    padding-top: 4em;
  }
}
</style>
